/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ArrowUp(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <rect
                        fill='none'
                        height='26'
                        id='canvas_background'
                        width='26'
                        x='-1'
                        y='-1'
                    />
                </g>
                <g fill={iconColor || '#000'}>
                    <path
                        d='m0.800061,11.906781l1.969431,1.957507l7.807535,-7.746728l0,16.895989l2.793868,0l0,-16.895989l7.793917,7.760264l1.983049,-1.971043l-11.174423,-11.106767l-11.174423,11.106767l0.001048,0z'
                        id='svg_1'
                        stroke='null'
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}